<app-user-tasks-edit *ngIf="!data.action?.id else tabs" [action]="data.action" [show_title]="true"></app-user-tasks-edit>

<ng-template #tabs>
  <div mat-dialog-title class="dialog-title p-3 pr-5">
    <h5>{{ is_edit ? 'Edit Task' : 'Task Viewer' }}</h5>
    <button
      mat-icon-button
      aria-label="Close dialog"
      matTooltip="Close this dialog."
      mat-dialog-close
      class="dialog-close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <hr class="m-0 p-0">

  <mat-dialog-content class="p-0">
    <mat-tab-group>
      <mat-tab label="Task Details">
        <app-actions-view *ngIf="!is_edit" [action]="data.action"></app-actions-view>
        <app-user-tasks-edit *ngIf="is_edit" [action]="data.action" [show_title]="false"></app-user-tasks-edit>
      </mat-tab>

      <mat-tab label="Notes">
        <app-actions-notes [action]="data.action" [is_edit]="is_edit"></app-actions-notes>
      </mat-tab>

      <mat-tab label="Files" *ngIf="data?.action?.files?.length">
        <div class="mx-3">
          <app-files-list [files]="data.action.files"></app-files-list>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>
</ng-template>
